module.exports = __webpack_public_path__ + "img/system28-details.16040186.png";